import { component } from 'picoapp';

class Tabs {
  constructor(el, ctx) {
    this.el = el;
    this.init();
  }
  init() {
    let el = this.el;
    this.tabs = el.querySelectorAll(':scope .tabs__tab');
    this.panesContainer = el.querySelector(':scope .tabs__content');
    this.panes = this.panesContainer.querySelectorAll(':scope .tabs__pane');

    const activeTab = [...this.tabs].find(t => t.classList.contains('.is-active')) || this.tabs[0]
    this.toggle(activeTab);

    this.tabs.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle(e.target);
      });
    });

    this.handleHashUpdate(true);
  }

  handleHashUpdate(autoScroll) {
    if (!window.location.hash) return; // Account for calls without an actual hash change

    const newTab = this.el.querySelector(':scope > .tabs__nav [data-identifier=' + window.location.hash.substring(1) + ']');
    // console.log('Handle hash update: ', newTab);
    if (newTab && autoScroll) {
      this.toggle(newTab);

      // Scroll tabs into view
      const tabsPos = this.el.offsetTop - 350;
      window.scrollTo({
        top: tabsPos,
        behavior: 'smooth' // Optional, adds animation
      });
    }
  }

  toggle(target) {
    let selectedTabIndex = Array.prototype.indexOf.call(this.tabs, target.closest('.tabs__tab'));
    let previousTabIndex = Array.prototype.indexOf.call(this.tabs, this.el.querySelector('.tabs__pane.is-active'));

    this.tabs.forEach((el) => {
      el.classList.remove('is-active');
    });
    this.panes.forEach((el) => {
      el.classList.remove('is-active');
    });

    this.enableTab(selectedTabIndex, previousTabIndex);
  }

  enableTab(nextTab, previousTab) {
    let self = this;
    // console.log(previousTab);
    if (previousTab >= 0) {
      this.panes[previousTab].classList.remove('is-active');
      this.tabs[previousTab].classList.remove('is-active');
    }
    this.panes[nextTab].classList.add('is-active');
    this.tabs[nextTab].classList.add('is-active');

    const event = new Event('render');
    this.el.dispatchEvent(event);
  }
}

export default component((node, ctx) => {
  new Tabs(node, ctx);
});
